import { SEOHead } from '../components/common/SEOHead';
import { InteractiveHero } from '../components/home/InteractiveHero';
import { TrustBar } from '../components/home/TrustBar';
import { ValuePropSection } from '../components/home/ValuePropSection';
import { ForWhoServiceSection } from '../components/home/ForWhoServiceSection';
import { FAQSeoSection, faqPageSchema } from '../components/home/FAQSeoSection';
import { BenefitsSection } from '../components/home/BenefitsSection';
import { AboutSection } from '../components/home/AboutSection';
import { CTASection } from '../components/home/CTASection';

// Schema.org ProfessionalService para el negocio
const businessSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": "https://www.realimentanaturalvet.com/#business",
  "name": "REALimenta",
  "url": "https://www.realimentanaturalvet.com/",
  "logo": "https://customer-assets.emergentagent.com/job_a1912b7e-066f-47ed-b71e-1adf7eca78cb/artifacts/nnj2xolp_Gemini_Generated_Image_fi3kv3fi3kv3fi3k-cutout.png",
  "image": "https://customer-assets.emergentagent.com/job_a1912b7e-066f-47ed-b71e-1adf7eca78cb/artifacts/41g5f4sr_3.png",
  "description": "Nutrición veterinaria online para perros y gatos. Consulta y seguimiento personalizado. Base en Málaga, atención en toda España.",
  "email": "realimenta.naturalvet@gmail.com",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Málaga",
    "addressRegion": "Andalucía",
    "addressCountry": "ES"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "36.7213",
    "longitude": "-4.4214"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Spain"
  },
  "serviceArea": {
    "@type": "Country",
    "name": "Spain"
  },
  "availableLanguage": "es-ES",
  "priceRange": "€€",
  "knowsAbout": [
    "Nutrición canina",
    "Nutrición felina",
    "Alimentación natural para perros",
    "Alimentación natural para gatos",
    "Dieta BARF",
    "Dieta casera para mascotas"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Servicios de nutrición veterinaria",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Valoración Nutricional Inicial",
          "description": "Estudio previo del caso y videollamada de 45 minutos para evaluar las necesidades nutricionales de tu mascota."
        },
        "price": "35",
        "priceCurrency": "EUR"
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pack Nutricional Específico",
          "description": "Valoración inicial completa más plan nutricional personalizado con ingredientes, cantidades y guía de transición."
        },
        "price": "100",
        "priceCurrency": "EUR"
      }
    ]
  }
};

export const HomePage = () => {
  return (
    <>
      <SEOHead
        title="REALimenta | Nutrición veterinaria online para perros y gatos (España)"
        description="Plan a medida basada en ciencia y adaptada a su salud y rutina. Base en Málaga, atención online en toda España. Valoración nutricional desde 35€."
        canonical="/"
        schema={[businessSchema, faqPageSchema]}
      />
      
      {/* 1. Hero interactivo (slider comida natural vs pienso) */}
      <InteractiveHero />
      
      {/* 2. Trust Bar */}
      <TrustBar />
      
      {/* 3. Propuesta de valor */}
      <ValuePropSection />
      
      {/* 4. Beneficios */}
      <BenefitsSection />
      
      {/* 5. ¿Para quién es este servicio? */}
      <ForWhoServiceSection />
      
      {/* 6. Sobre mí (Mi enfoque) */}
      <AboutSection />
      
      {/* 7. FAQ SEO (14 preguntas con acordeón + CTA) */}
      <FAQSeoSection />
      
      {/* 8. CTA final */}
      <CTASection />
    </>
  );
};

export default HomePage;
